module.exports = __webpack_public_path__ + "static/media/go-ahead.8c87c5b2.svg";